
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navItems = [
    { name: 'トップ', path: '/' },
    { name: '当院について', path: '/about' },
    { name: '求人情報', path: '/recruit' },
    { name: 'ブログ', path: '/blog' },
    { name: 'ご予約', path: '/booking' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 shadow-md' : 'bg-white/90'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <h1 className="text-xl sm:text-2xl font-bold text-primary">おかやま鍼灸院</h1>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === item.path
                    ? 'text-primary'
                    : 'text-gray-600 hover:text-primary'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Desktop Contact Info */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href="tel:086-012-3456"
              className="hidden lg:flex items-center gap-2 text-primary font-semibold whitespace-nowrap"
            >
              <i className="ri-phone-fill text-xl"></i>
              <span className="text-lg">086-012-3456</span>
            </a>
            <Link
              to="/contact"
              className="bg-accent text-white px-6 py-2.5 rounded-full font-medium text-sm hover:bg-accent/80 transition-colors whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-gray-600 hover:text-primary transition-colors cursor-pointer"
            aria-label="メニュー"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
            <nav className="flex flex-col gap-4 mt-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`text-base font-medium transition-colors duration-200 py-2 ${
                    location.pathname === item.path
                      ? 'text-primary'
                      : 'text-gray-600 hover:text-primary'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="/contact"
                className="bg-accent text-white px-6 py-3 rounded-full font-medium text-base hover:bg-accent/80 transition-colors text-center cursor-pointer mt-2"
              >
                お問い合わせ
              </Link>
              <a
                href="tel:086-012-3456"
                className="flex items-center justify-center gap-2 text-primary font-semibold py-2"
              >
                <i className="ri-phone-fill text-xl"></i>
                <span className="text-lg">086-012-3456</span>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
